import { createSelector } from '@reduxjs/toolkit';
import { TeamPlayersNumber } from 'shared/types/team-players-number';
import { RootState } from 'store/store';

export const championshipStoreSelector = (state: RootState) => state.championships.championship;

export const championshipIsLoadingSelector = createSelector(championshipStoreSelector, (state) => state.isLoading);

export const championshipIsLoadedSelector = createSelector(championshipStoreSelector, (state) => state.isLoaded);

export const championshipTeamsIsLoadingSelector = (championshipId: number) =>
  createSelector(championshipStoreSelector, (state) => state.data?.byId[championshipId]?.teamsFlags.isLoading || false);

export const championshipTeamsIsLoadedSelector = (championshipId: number) =>
  createSelector(championshipStoreSelector, (state) => state.data?.byId[championshipId]?.teamsFlags.isLoaded || false);

export const championshipTeamsDataSelector = (championshipId: number) =>
  createSelector(championshipStoreSelector, (state) => state.data?.byId[championshipId]?.teams || []);

export const championshipISavingSelector = createSelector(championshipStoreSelector, (state) => state.isSaving);

export const championshipDataSelector = (championshipId: number) =>
  createSelector(championshipStoreSelector, (state) => state.data?.byId[championshipId]);

export const allIdsChampionshipsDataSelector = createSelector(championshipStoreSelector, (state) => state.data?.allIds);

export const championshipIsMatchSavingSelector = (championshipId: number) =>
  createSelector(championshipStoreSelector, (state) => state.data?.byId[championshipId]?.isMatchSaving || false);

export const championshipSymbolicTeamSelectedSelector = (championshipId: number) =>
  createSelector(championshipStoreSelector, (state) => state.data?.byId[championshipId]?.selectedSymbolicTeam || null);

export const championshipSymbolicTeamIsSavingSelector = (championshipId: number) =>
  createSelector(championshipStoreSelector, (state) => state.data?.byId[championshipId]?.isSymbolicTeamSaving || false);

export const championshipSymbolicTeamFormShownSelector = (championshipId: number) =>
  createSelector(championshipStoreSelector, (state) => state.data?.byId[championshipId]?.showSymbolicTeamForm || false);

export const championshipTeamPlayersNumberSelector = (championshipId: number) =>
  createSelector(
    championshipStoreSelector,
    (state) => state.data?.byId[championshipId]?.settings.teamPlayersNumber || TeamPlayersNumber.FIVE,
  );

export const championshipSettingsSelector = (championshipId: number) =>
  createSelector(championshipStoreSelector, (state) => state.data?.byId[championshipId]?.settings);

export const championshipIsDeletingSelector = createSelector(championshipStoreSelector, (state) => state.isDeleting);
